import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'arrow-icon',
  templateUrl: './arrow-icon.component.html',
  styles: [':host{display: inherit;}']
})
export class ArrowIconComponent implements OnInit, OnChanges {

  @Input() arrowColor: string = '#000'
  @Input() angle: ("left" | "right" | "up" | "down") = "left"
  @Input() arrowWidth: string  = '8px'
  @Input() arrowHeight: string  = '8px'
  rotateDeg = 0;

  constructor() { }

  ngOnInit(): void {
    this.changeAngle()
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.angle && changes.angle.currentValue !== changes.angle.previousValue){
      this.angle = changes.angle.currentValue
      this.changeAngle()
    }
  }

  changeAngle(){
    if(this.angle === 'up'){
      this.rotateDeg = 90
    } else if(this.angle === 'right'){
      this.rotateDeg = 180
    } else if(this.angle === 'down'){
      this.rotateDeg = 270
    }
  }
}
